import _ from 'lodash';
import { useState } from 'react';

export default function useMemento(initialValue:any) {
  const [value, _setValue] = useState(initialValue);
  const [history, setHistory] = useState([initialValue]);

  function setValue(value:any) {
    if (!_.isEqual(value, lastHistoryElement())) {
      setHistory([...history, value]);
      _setValue(value);
    }
  }

  function popHistory() {
    if (history.length > 1) {
      setHistory(_.initial(history));
    }
  }

  function lastHistoryElement() {
    return history[history.length - 1];
  }

  function memento() {
    const m = lastHistoryElement();

    if (!_.isEqual(value, lastHistoryElement())) {
      setValue(lastHistoryElement());
    }

    popHistory();

    return m;
  }

  return [value, setValue, memento];
}
  